import api from "./api";

export const createRecurrentTask = async (taskData) => {
  try {
    console.log("[TASK RECURRENCE] Criando tarefa recorrente:", taskData);
    const response = await api.post("/tasks/recurrent", taskData);
    console.log("[TASK RECURRENCE] Resposta do servidor:", response.data);
    return response.data; // Retornar apenas os dados, não o response completo
  } catch (error) {
    console.error("[TASK RECURRENCE] Erro ao criar tarefa recorrente:", error);
    throw error;
  }
};

export const stopRecurrence = (taskId) => {
  return api.delete(`/tasks/${taskId}/recurrence`);
};

export const processRecurrentTasks = () => {
  return api.post("/tasks/process-recurrence");
};

export default {
  createRecurrentTask,
  stopRecurrence,
  processRecurrentTasks
};
